export default __webpack_public_path__ + "static/media/nyc.321d9d79.png";